import Service, { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class BetaFeaturesService extends Service {
  @service currentUser;

  enabled(featureName) {
    //return false;
    //console.log('enabled', featureName);
    if (!this.currentUser.user) {
      return false;
    }
    return this.currentUser.user.betaFeatures?.indexOf(featureName) >= 0;
  }

  get commentsEnabled() {
    return true;
    //console.log('commentsEnabled?')
    return this.enabled('comments');
  }

  get v2SyncEnabled() {
    //console.log('commentsEnabled?')
    return this.enabled('v2-sync');
  }

  get playlistsEnabled() {
    return this.enabled('playlists');
  }
}
